import Search from "./Search";
import ScholarshipList from "./ScholarshipList";
import React, {useEffect, useState} from "react";
import ScholarshipService from "../services/ScholarshipService";
import { useTranslation } from 'react-i18next';

/**
 *
 */
export default function FindScholarships() {
    const { t, i18n } = useTranslation();
    const [ allScholarships, setAllScholarships ] = useState([]);
    const [ scholarships, setScholarships ] = useState([]);   // the scholarships found with current filters

    const levelDoctorial = [t('scholarship.categories.research')];
    const levelBasicAdvanced = [t('scholarship.categories.nation'), t('scholarship.categories.other'), t('scholarship.categories.faculty')];

    //API keys (/api/sok)
    const keys = ["namn", "kategori", "beskrivning", "typer", "behorigheter", "nationer", "fakulteter", "slaktingar", "lan"];
    
    useEffect(()=>{
        ScholarshipService.getAllScholarships(i18n.resolvedLanguage)
            .then(response => {
                setAllScholarships(response.data);
                setScholarships(response.data);
            })
            .catch(e => {
                console.log(e);
            });
    },[i18n.resolvedLanguage])

    const contains = (filterArray, property) => {
        if (Array.isArray(property)) {
            return property.some(p => filterArray.includes(p))
        } else {
            return filterArray.includes(property);
        }
    }

    const isEmpty = (filters) => {
        return filters.faculties.length === 0 && filters.nations.length === 0 && filters.counties.length === 0 &&
            filters.kinship.length === 0 && filters.qualifications.length === 0 && filters.levels.length === 0 &&
            filters.travel.length === 0 && filters.otherUniversities.length === 0 && filters.searchInput.length === 0 && filters.general.length === 0;
    }

    const filterLevel = (filterArray, property) => {
        let levels = [];
        if (filterArray.includes(t('filter.level.basic_advanced'))) {
            levels = levels.concat(levelBasicAdvanced);
        }
        if (filterArray.includes(t('filter.level.doctorial'))) {
            levels = levels.concat(levelDoctorial);
        }
        
        return contains(levels, property)
    }

    const filterSearch = (filterValue, scholarship) => {
        return (keys.some(key => containsIgnoreCase(filterValue, scholarship[key])))
    }

    const containsIgnoreCase = (filterValue, itemValue) => {
        return itemValue !== null && itemValue.toString().toLowerCase().includes(filterValue.toLowerCase())
    }

    const filter = (filters) => {
        const newScholarships = allScholarships.filter(scholarship => {
            if (isEmpty(filters)) {
                return true;
            } else if ((filters.faculties.length === 0 || (filters.faculties.length > 0 && contains(filters.faculties, scholarship.fakulteter)))
                && (filters.nations.length === 0 || (filters.nations.length > 0 && contains(filters.nations, scholarship.nationer)))
                && (filters.counties.length === 0 || (filters.counties.length > 0 && contains(filters.counties, scholarship.lan)))
                && (filters.levels.length === 0 || (filters.levels.length > 0 && filterLevel(filters.levels, scholarship.typer)))
                && (filters.kinship.length === 0 || (filters.kinship.length > 0 && contains(filters.kinship, scholarship.slaktingar)))
                && (filters.qualifications.length === 0 || (filters.qualifications.length > 0 && contains(filters.qualifications, scholarship.behorigheter)))
                && (filters.travel.length === 0 || contains(filters.travel, scholarship.kategori))
                && (filters.otherUniversities.length === 0 || scholarship.fleraUniversitet)
                && (filters.general.length === 0 || (filters.general.length > 0 && contains(filters.general, scholarship.typer)))
                && (filters.searchInput.length === 0 || (filters.searchInput.length > 0 && filterSearch(filters.searchInput, scholarship)))) {
                return true;
            }
            
            return false;
        });
        setScholarships(newScholarships);
    }

    const totalNrOfScholarships = () => {
        const copyAllScholarships = [...allScholarships]
        return copyAllScholarships.length
    }

    function render() {
        return (
            <>
                <p>{t('find_scholarships.warning_several_filters')}</p>
                <p>{t('find_scholarships.info_general_scholarships')}</p>
                <p>{t('find_scholarships.info_application_open')}</p>
                <p>{t('find_scholarships.info_donations')}</p>
                <h3>{t('find_scholarships.subheading')}</h3>
                <p>{t('find_scholarships.info_search_scholarships_1')}</p>
                <p>{t('find_scholarships.info_search_scholarships_2')}</p>
                <p>{t('find_scholarships.info_search_scholarships_3')}</p>
                <section className="component mb-5" id="component-search-list" aria-labelledby="section-header-search-list">
                    <div className="anchor" id="search-list"></div>

                    <Search filterMethod={filter} />
                    <ScholarshipList scholarships={scholarships} allScholarships={allScholarships} totalNrOfScholarships={totalNrOfScholarships()} />
                </section>
            </>
        )
    }

    return (
        <React.Fragment>
            <h1>{t('find_scholarships.title')}</h1>

            { (allScholarships !== null && allScholarships.length > 0) && render() }
        </React.Fragment>
    );
}